import { useState } from "react";
import clsx from "clsx";
import { makeStyles } from "@mui/styles";
import { useSelector } from "react-redux";

import { palette } from "../../../theme/palette";

import { unallocatedLocationsSelector } from "../../../reducers/matrixProfile/selectors";

import { QuestionMarkIcon } from "../../Icons";
import { View } from "../../Base";
import UnallocatedLocationsPopover from "./UnallocatedLocationsPopover";

const useStyles = makeStyles(() => ({
  container: {
    display: "flex",
    alignItems: "center",
  },
  infoIcon: {
    margin: "0 4px 0 15px",
    fill: palette.typography.white.high,
    cursor: "pointer",
  },
  questionMarkIcon: {
    width: "16px",
    height: "16px",
  },
  fillOrange: {
    fill: palette.orange,
  },
}));

const UnallocatedLocationsComponent = () => {
  const styles = useStyles();
  const unallocatedLocations = useSelector(unallocatedLocationsSelector);
  const [questionMarkAnchorEl, setQuestionMarkAnchorEl] = useState(null);

  if (!unallocatedLocations.length) return null;

  return (
    <View className={styles.container}>
      <QuestionMarkIcon
        className={clsx(
          styles.infoIcon,
          styles.questionMarkIcon,
          questionMarkAnchorEl ? styles.fillOrange : null
        )}
        onClick={(event) => setQuestionMarkAnchorEl(event.currentTarget)}
      />
      {unallocatedLocations.length}
      <UnallocatedLocationsPopover
        unallocatedLocations={unallocatedLocations}
        open={!!questionMarkAnchorEl}
        onClose={() => setQuestionMarkAnchorEl(null)}
        anchorEl={questionMarkAnchorEl}
      />
    </View>
  );
};

export default UnallocatedLocationsComponent;
